import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCog, faSave, faSpinner)
import webmessage from '../../globalComponents/webmessage.vue'
Vue.component('webmessage', webmessage)
Vue.config.ignoredElements = ['wsm']
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
var mountEl = document.getElementById('researchcorner')
new Vue({
  render: h => h(App),
  name: 'researchCornerKroppensABC',
  data: {
    settings: mountEl.dataset.settings == "" ? {"idForSection": 0, "default": 5, "mode": "news"} : JSON.parse(mountEl.dataset.settings),
    cat: parseInt(mountEl.dataset.news),
    admin: Boolean(mountEl.dataset.admin),
    isadmin: Boolean(mountEl.dataset.admin),
    ingredients: mountEl.dataset.ingredients == "true" ? true : false,
    translations: JSON.parse(mountEl.dataset.language),
    contentid: mountEl.dataset.contentid,
    pageid: mountEl.dataset.pageid,
    webhost: mountEl.dataset.webhost,
  }
}).$mount(mountEl)
